import React, { useEffect, useState } from "react";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import "./logs-view-details.css";
import FileUpload from "../FileUploads/FileUpload";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";

const LogsViewDetails = ({
  match,
  history,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  regularizationDetailsForManager,
  regularizationDetails = []
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [fileDownload, setFileDownload] = useState('');

  useEffect(() => {
    (async () => {
      const listStatus = [1,2];
      setIsLoading(true);
      await regularizationDetailsForManager(1, listStatus,
        match?.params?.id,
        match?.params?.type
      );
      setIsLoading(false);
    })();
  }, [regularizationDetailsForManager]);
  


  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"View Details"} history={history} />
            {regularizationDetails &&
              regularizationDetails?.data &&
              regularizationDetails?.data?.data &&
              regularizationDetails?.data?.data?.length > 0 &&
              regularizationDetails?.data?.data[0]?.regularization_type &&
              regularizationDetails?.data?.data[0]?.regularization_type == "REGULARIZATION" && (
                <div className="container-fluid common-bg">
                  <div className="container-fluid bootstrap snippets bg-white">
                    <div className="container">
                      {/* <div className="text-center">
                        <h1>Regularization Request</h1>
                      </div> */}
                      <form>
                        <div className="form-group">
                          <label>Reason for missed attendance</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                              regularizationDetails?.data?.data[0]
                                ?.reason_for_missed_attendance
                            }
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Location of work</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                              regularizationDetails?.data?.data[0]?.location_of_work
                            }
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Date</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                              regularizationDetails?.data?.data[0]?.regularization_date
                            }
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>From</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.check_in_time}
                          />
                        </div>
                        <div className="form-group">
                          <label>To</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.check_out_time}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="attachments">
                            Upload attachments
                          </label>
                          {/* <FileUpload
                            id={"addAttachment"}
                            accept=".png,.jpg,.jpeg"
                            documentUploadUrl={documentUploadUrlPublic}
                            documentUrlData={documentUrlDataPublic}
                            prefilledFilename={
                              regularizationDetails?.data?.data[0]?.attachment
                                ? "attachment"
                                : ""
                            }
                            onChange={() => {}}
                          /> */}
                          
                        </div>
                        {regularizationDetails?.data?.data[0]?.attachment ? (
                          <button className="btn btn-primary btn-sm mb-4">
                              <a href={regularizationDetails?.data?.data[0]?.attachment} target="_blank" style={{'color': 'white'}}>
                                <i className="bi bi-download"></i> Download
                              </a>
                            </button>
                        ) : (
                          <p>No attachment available</p>
                        )}

                        <div className="form-group">
                          <label htmlFor="message">Reason</label>
                          <textarea
                            id="message"
                            className="date-time"
                            value={regularizationDetails?.data?.data[0]?.message}
                            disabled
                          ></textarea>
                        </div>
                        <div className="form-group">
                          <label>Status</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                                regularizationDetails?.data?.data[0]?.regularization_status === 1
                                  ? "Approved"
                                  : regularizationDetails?.data?.data[0]?.regularization_status === 2
                                  ? "Rejected"
                                  : "Unknown"
                              }                          
                          />
                        </div>
                        {regularizationDetails?.data?.data[0]?.manager_remark && (
                            <div className="form-group">
                                <label htmlFor="message">Manager Remark</label>
                                <textarea
                                    id="message"
                                    className="date-time"
                                    value={regularizationDetails?.data?.data[0]?.manager_remark}
                                    disabled
                                ></textarea>
                            </div>
                        )}
                        {regularizationDetails?.data?.data[0]?.approved_rejection_date && (
                            <div className="form-group">
                            <label>Action Date</label>
                            <input
                                className="date-time"
                                type="text"
                                value={regularizationDetails?.data?.data[0]?.approved_rejection_date}
                                disabled                          
                            />
                            </div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              )}
            {regularizationDetails &&
              regularizationDetails?.data &&
              regularizationDetails?.data?.data &&
              regularizationDetails?.data?.data?.length > 0 &&
              regularizationDetails?.data?.data[0]?.regularization_type &&
              regularizationDetails?.data?.data[0]?.regularization_type === "WOOO" && (
                <div className="container-fluid common-bg">
                  <div className="container-fluid bootstrap snippets bg-white">
                    <div className="container">
                      <div className="text-center">
                        <h5>Work Out Of Office Request</h5>
                      </div>
                      <form>
                        <div className="form-group mt-5">
                          <label>Requester Name</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.requester_name}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Requester Email</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.requester_email}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Check-in DateTime</label>
                          <input
                            className="date-time"
                            type="text"
                            value={regularizationDetails?.data?.data[0]?.check_in_date}
                            disabled
                          />
                        </div>
                        {regularizationDetails?.data?.data[0]?.check_out_date &&
                          regularizationDetails?.data?.data[0]?.check_out_date !=
                            undefined &&
                          regularizationDetails?.data?.data[0]?.check_out_date !=
                            null && (
                            <div className="form-group">
                              <label>Check-out DateTime</label>
                              <input
                                className="date-time"
                                type="text"
                                value={
                                  regularizationDetails?.data?.data[0]?.check_out_date
                                }
                                disabled
                              />
                            </div>
                          )}
                        <div className="form-group">
                          <label>Check-in Message</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                              regularizationDetails?.data?.data[0]?.check_in_comments
                            }
                            disabled
                          />
                        </div>
                        {regularizationDetails?.data?.data[0]?.check_out_date &&
                          regularizationDetails?.data?.data[0]?.check_out_date !=
                            undefined &&
                          regularizationDetails?.data?.data[0]?.check_out_date !=
                            null && (
                            <div className="form-group">
                              <label>Check-out Message</label>
                              <input
                                className="date-time"
                                type="text"
                                value={
                                  regularizationDetails?.data?.data[0]
                                    ?.check_out_comments
                                }
                                disabled
                              />
                            </div>
                          )}
                        <div className="form-group">
                          <label>Status</label>
                          <input
                            className="date-time"
                            type="text"
                            value={
                                regularizationDetails?.data?.data[0]?.regularization_status === 1
                                  ? "Approved"
                                  : regularizationDetails?.data?.data[0]?.regularization_status === 2
                                  ? "Rejected"
                                  : "Unknown"
                              }                          
                          />
                        </div>
                        {regularizationDetails?.data?.data[0]?.regularization_approver_remark &&
                          regularizationDetails?.data?.data[0]?.regularization_approver_remark != undefined &&
                          regularizationDetails?.data?.data[0]?.regularization_approver_remark != null && (
                            <div className="form-group">
                                <label htmlFor="message">Manager Remark</label>
                                <textarea
                                    id="message"
                                    className="date-time"
                                    value={regularizationDetails?.data?.data[0]?.regularization_approver_remark}
                                    disabled
                                ></textarea>
                            </div>
                        )}
                        {regularizationDetails?.data?.data[0]?.regularization_approved_date &&
                          regularizationDetails?.data?.data[0]?.regularization_approved_date != undefined &&
                          regularizationDetails?.data?.data[0]?.regularization_approved_date != null  && (
                            <div className="form-group">
                            <label>Action Date</label>
                            <input
                                className="date-time"
                                type="text"
                                value={regularizationDetails?.data?.data[0]?.regularization_approved_date}       
                                disabled                   
                            />
                            </div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LogsViewDetails;
